export const validateTag = (value: string): boolean => {
  const regex = /^[a-zA-Z0-9__+]+$/;
  return regex.test(value);
};
